import { render, staticRenderFns } from "./TeacherCardWithDetail.vue?vue&type=template&id=2d91c189&scoped=true&"
import script from "./TeacherCardWithDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherCardWithDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCardWithDetail.vue?vue&type=style&index=0&id=2d91c189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91c189",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VHover})
